import { Switch, useTestIds } from "@homebound/beam";
import { useState } from "react";
import { PaymentScheduleTable } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/components/PaymentScheduleTable";
import { PaymentScheduleTable_CommitmentLikeFragment } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/components/PaymentScheduleTable.generated";
import { useSaveCommitmentMutation } from "../CommitmentPage.generated";

type PaymentScheduleSectionProps = { commitment: PaymentScheduleTable_CommitmentLikeFragment };

export function PaymentScheduleSection(props: PaymentScheduleSectionProps) {
  const tid = useTestIds({});
  const { commitment } = props;
  const hasDraws = commitment.draws.nonEmpty;
  const canEdit = commitment.canEditDraws.allowed;
  const [drawsEnabled, setDrawsEnabled] = useState(false);
  const [saveCommitment] = useSaveCommitmentMutation();

  return (
    <section {...tid.paymentScheduleSection}>
      {canEdit && !hasDraws && (
        <Switch label="Enable Draws" selected={drawsEnabled} onChange={setDrawsEnabled} {...tid.enableDraws} />
      )}
      {(hasDraws || drawsEnabled) && (
        <PaymentScheduleTable
          commitment={commitment}
          mode={canEdit && (drawsEnabled || hasDraws) ? "edit" : "view"}
          showStatus
          showTitle
          onSubmit={async (input) => {
            await saveCommitment({ variables: { input } });
          }}
        />
      )}
    </section>
  );
}
